/**
 * Que el navegador no borre los datos de la tienda.
 *
 * Everything this device has not sent yet, and everything it works from without a signal, lives
 * in the browser's storage, and a browser short of space may clear a site's storage without
 * asking, starting with the sites it thinks matter least (`AUDITORIAS.md` item 3). Asked, it can
 * mark the storage as the person's to clear and nobody else's. Chrome decides by itself, and says
 * yes to an app added to the home screen; Firefox asks the person. Asking again costs nothing.
 */

export interface Almacenamiento {
  /** Whether the browser has promised to keep it. Null: this browser cannot say. */
  conservado: boolean | null;
  /** Bytes this app takes, as the browser reckons them. */
  usado: number | null;
}

const almacen = (): StorageManager | undefined =>
  typeof navigator === 'undefined' ? undefined : navigator.storage;

/** Asks, unless it has already been promised. Null where the browser has no way to ask. */
export async function pedirQueConserve(): Promise<boolean | null> {
  const s = almacen();
  if (!s?.persist || !s.persisted) return null;
  try {
    return (await s.persisted()) || (await s.persist());
  } catch {
    return null;
  }
}

export async function leerAlmacenamiento(): Promise<Almacenamiento> {
  const s = almacen();
  let conservado: boolean | null = null;
  let usado: number | null = null;
  try {
    if (s?.persisted) conservado = await s.persisted();
  } catch {
    // Left as "cannot say".
  }
  try {
    if (s?.estimate) usado = (await s.estimate()).usage ?? null;
  } catch {
    // Likewise.
  }
  return { conservado, usado };
}
